import { render, staticRenderFns } from "./checkUpPop.vue?vue&type=template&id=04eba47d"
import script from "./checkUpPop.vue?vue&type=script&lang=js"
export * from "./checkUpPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04eba47d')) {
      api.createRecord('04eba47d', component.options)
    } else {
      api.reload('04eba47d', component.options)
    }
    module.hot.accept("./checkUpPop.vue?vue&type=template&id=04eba47d", function () {
      api.rerender('04eba47d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpPop.vue"
export default component.exports